import { recordFromSnapshot } from 'utils/firebaseUtils'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_TABLE_ERROR = 'CREATE_TABLE_ERROR'
export const CREATE_TABLE_SUCCESS = 'CREATE_TABLE_SUCCESS'
export const DELETE_TABLE_ERROR = 'DELETE_TABLE_ERROR'
export const DELETE_TABLE_SUCCESS = 'DELETE_TABLE_SUCCESS'
export const UPDATE_TABLE_ERROR = 'UPDATE_TABLE_ERROR'
export const UPDATE_TABLE_SUCCESS = 'UPDATE_TABLE_SUCCESS'
export const ADD_SIDE_TABLE = 'ADD_SIDE_TABLE'
export const REMOVE_SIDE_TABLE = 'REMOVE_SIDE_TABLE'
export const LOADING_TABLE = 'LOADING_TABLE'
export const SELECT_CURRENT_TABLE = 'SELECT_CURRENT_TABLE'
// ------------------------------------
// Actions
// ------------------------------------

export function addTransactionToTable(table, transaction) {
  return (dispatch, getState) => {
    dispatch(updateTable(table, { currentTransaction: transaction }))
  }
}

export function removeTransactionFromTable(table) {
  return (dispatch, getState) => {
    dispatch(updateTable(table, { currentTransaction: null }))
  }
}

export function selectCurrentTable(tableId) {
  return (dispatch, getState) => {
    const { tables } = getState()
    const table = tables.list.filter(t => {
      return t.key === tableId
    })[0]
    if (table) {
      dispatch({
        type: SELECT_CURRENT_TABLE,
        payload: table
      })
    }
  }
}
export function createTable(type, num) {
  return (dispatch, getState) => {
    const { firebase, settings } = getState()
    const { size } = settings
    let x = Math.floor(Math.random() * Math.floor(size.width - 200))
    let y = Math.floor(Math.random() * Math.floor(size.height - 100))
    x = x % 2 ? x + 1 : x
    y = y % 2 ? y + 1 : y
    const key = firebase.child(`tables`).push().key
    const table = {
      name: `Table ${num}`,
      num: num,
      posX: x,
      posY: y,
      isVertical: false,
      type: type,
      currentTransaction: null
    }
    firebase.child(`tables/${key}`).set(table, error => {
      if (error) {
        console.error('ERROR @ createTABLE :', error)
        dispatch({
          type: CREATE_TABLE_ERROR,
          payload: error
        })
      }
    })
  }
}

export function deleteTable(table) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('tables/' + table.key).remove(error => {
      if (error) {
        console.error('ERROR @ createTABLE :', error)
        dispatch({
          type: DELETE_TABLE_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateTable(table, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()

    firebase.child('tables/' + table.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateTable :', error)
        dispatch({
          type: UPDATE_TABLE_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerTablesListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('tables')
    ref.on('child_added', snapshot =>
      dispatch({
        type: CREATE_TABLE_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_changed', snapshot =>
      dispatch({
        type: UPDATE_TABLE_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_TABLE_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createTable,
  updateTable,
  selectCurrentTable,
  registerTablesListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_TABLE_SUCCESS]: (state, action) => {
    return Object.assign({}, state, { list: [...state.list, action.payload] })
  },
  [CREATE_TABLE_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_TABLE_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(table => {
        return table.key === action.payload.key ? action.payload : table
      })
    }),
  [UPDATE_TABLE_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_TABLE_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(table => {
        return table.key !== action.payload.key
      })
    }),
  [DELETE_TABLE_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_CURRENT_TABLE]: (state, action) =>
    Object.assign({}, state, { currentTable: action.payload }),
  [LOADING_TABLE]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(table => {
        return table.key === action.tableKey
          ? { ...table, loading: true }
          : table
      })
    })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], currentTable: {} }
export default function tableReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/table.js